import { all } from "redux-saga/effects";
import { watchcontactEnquiryTableWorker, watchcontactEnquiryViewWorker } from "../contact-enquiry-saga";

export default function* contactEnquiryRootSaga() {
  yield all([
    watchcontactEnquiryTableWorker(),
    watchcontactEnquiryViewWorker(),
  ]);
}
